import {
	ApplicationConfig,
	importProvidersFrom,
	inject,
	isDevMode,
	provideAppInitializer,
	provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { registerLocaleData } from "@angular/common";
import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi,
} from "@angular/common/http";
import es from "@angular/common/locales/es";
import { FormsModule } from "@angular/forms";
import {
	TranslocoService,
	provideTransloco,
	provideTranslocoTranspiler,
} from "@jsverse/transloco";
import { provideStore } from "@ngrx/store";
import { es_ES, provideNzI18n } from "ng-zorro-antd/i18n";
import { firstValueFrom } from "rxjs";
import { JwtInterceptor } from "../domain/service/network/jwt.interceptor";
import { routes } from "./app.routes";
import { provideNzIcons } from "./icons-provider";
import { TranslocoHttpLoader } from "./transloco-loader";
import { SinglePassTranspiler } from "./transloco-transpiler";

registerLocaleData(es);

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideNzIcons(),
		provideNzI18n(es_ES),
		importProvidersFrom(FormsModule),
		provideHttpClient(withInterceptorsFromDi()),
		provideStore(),
		provideTransloco({
			config: {
				availableLangs: ["es"],
				defaultLang: "es",
				fallbackLang: "es",
				missingHandler: { useFallbackTranslation: true },
				reRenderOnLangChange: true,
				prodMode: !isDevMode(),
			},
			loader: TranslocoHttpLoader,
		}),
		provideTranslocoTranspiler(SinglePassTranspiler),
		provideAppInitializer(() => {
			const transloco = inject(TranslocoService);
			return firstValueFrom(transloco.load(transloco.getDefaultLang()), {
				defaultValue: undefined,
			});
		}),
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
	],
};
